<template>
    <el-dialog title="题目" :visible.sync="dialogVisible" :close-on-click-modal="false" width="700px">
        <div class="content">
            <div v-for="(item, index) in subData" :key="index">
                <div class="sub-top">
                    <div>{{ index + 1 + '.' }}</div>
                    <div>{{ `[${item.questionType}]` }}</div>
                    <div v-html="item.questionStem" style="white-space: var(--lineWrap);"></div>
                </div>
                <el-radio-group v-model="item.value" v-if="['判断题', '单选题'].includes(item.questionType)">
                    <el-radio v-for="(item1, index1) in item.questionOptionVOS" :label="item1.id" :key="index1">
                        <p style="margin-right: 0.5rem;">{{ alphabet[index1] }}</p>
                        <p v-html="item1.content"></p>
                    </el-radio>
                </el-radio-group>
                <el-checkbox-group v-model="item.value" v-else-if="item.questionType == '多选题'">
                    <el-checkbox v-for="(e, i) in item.questionOptionVOS" :key="i" :label="e.id">
                        <div style="display: flex;">
                            <div>{{ alphabet[i] + '.' }}</div>
                            <div v-html="e.content" style="white-space: var(--lineWrap);"></div>
                        </div>
                    </el-checkbox>
                </el-checkbox-group>
                <div v-else-if="item.questionType == '填空题'">
                    <div v-for="(e, i) in item.questionOptionVOS" :key="i"
                    style="display: flex;margin-top: 2rem;align-items: center;">
                    <div>{{ alphabet[i] + '：' }}</div>
                    <el-input v-model="e.value"
                        style="width: 10rem;"></el-input>
                </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button v-if="openCourseId" type="primary" style="margin-left: 3rem;" @click="save">提交</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { SubmitQuestion } from '@/api/subject';
export default {
    data() {
        return {
            dialogVisible: false,
            subData: [],
            alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
        }
    },
    computed:{
        openCourseId(){
            return this.$route.query.openCourseId||'';
        },
    },
    methods: {
        save() {
            var params={};
            var answerArr=[];
            this.subData.forEach(item=>{
                var obj={};
                obj.questionId=item.questionId;
               if(item.questionType=='多选题'){
                obj.answer=item.value;
               }else if(['单选题','判断题'].includes(item.questionType)){
                obj.answer=[item.value];
               }else if(item.questionType=='填空题'){
                obj.answer=item.questionOptionVOS.map(el=>el.value)
               }else{
                return;
               }
               answerArr.push(obj);
            })
            params.userQuestionAnswerPOS=answerArr;
            var teachingUnitId=localStorage.getItem('currentId');
            params.businessId=this.openCourseId+'-'+teachingUnitId;
            params.questionSource='video_question';
            SubmitQuestion(params).then(res=>{
                if(res.code==200){
                    this.$msg({
                    showClose: true,
                    message: '提交成功',
                    type: 'success'
                    });
                    this.$emit('submit_success');
                    this.dialogVisible=false;
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.sub-top {
    display: flex;

    &> :nth-child(1) {
        font-weight: 700;
        margin-right: 1rem;
    }
}

.dialog-footer {
    display: flex;
    justify-content: center;
}

.content {
    max-height: 50rem;
    overflow: auto;

    &> :nth-child(n) {
        margin-top: 2rem;
    }

    &> :nth-child(1) {
        margin-top: 0;
    }
}

/deep/.el-radio-group {
    display: flex;
    flex-direction: column;
}

/deep/.el-radio {
    margin-top: 2rem;
    display: flex;
}

/deep/.el-checkbox-group {
    display: flex;
    flex-direction: column;
}

/deep/.el-checkbox {
    margin-top: 2rem;
}

/deep/.el-radio__label {
    display: flex;
}
/deep/.el-input__inner {
    border: 1px solid transparent;
    border-bottom: 2px solid #334681;
    border-radius: 0;
}
</style>